import { ComponentType, createElement, FC } from 'react';
import { useLocation, useParams, Location } from 'react-router-dom';
import { push, replace, goBack } from 'utils/navigation/navigate';

/**
 * Compatibility wrapper so legacy RFC components still receive match/location/history.
 */
export function withRouter(Component: ComponentType<any>): FC {
  const Wrapped: FC = (props) => {
    const params = useParams();
    const location = useLocation();
    const match = {
      params: params as any,
      isExact: true,
      path: location.pathname,
      url: location.pathname,
    };
    const history = {
      push,
      replace,
      goBack,
      location,
    };
    return createElement(Component, {
      ...props,
      match,
      location: location as Location & { state: unknown },
      history,
    });
  };
  Wrapped.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}
